'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'thumbtack';
var width = 384;
var height = 512;
var aliases = [128204,128392,"thumb-tack"];
var unicode = 'f08d';
var svgPathData = ['M55.6 304l272.8 0c-9.5-30.1-27.6-57.8-51.2-78.3l-15.2-13.1-1.3-20-9.6-144.6-118.2 0-9.6 144.6-1.3 20-15.2 13.1C83.2 246.2 65.1 273.9 55.6 304z', 'M75.4 189.4C41.5 218.7 16.5 259.6 5.8 304 2 319.7 0 335.8 0 352l384 0c0-16.2-2-32.3-5.8-48-10.7-44.4-35.7-85.3-69.6-114.6l-9.4-141.4 52.8 0 0-48-320 0 0 48 52.8 0-9.4 141.4zM132.9 48l118.2 0 9.6 144.6 1.3 20 15.2 13.1c23.6 20.4 41.6 48.2 51.2 78.3L55.6 304c9.5-30.1 27.6-57.8 51.2-78.3l15.2-13.1 1.3-20 9.6-144.6zM168 400l0 144 48 0 0-144-48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbtack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;